import React from 'react';
import securityShieldIcon from '../../assets/icons/security-shield-icon.svg';
import mastercardLogo from '../../assets/images/mastercard-logo.svg';
import dayliPromiseImage from '../../assets/icons/dayli-promise-image.png';
import starDecoration from '../../assets/icons/star-decoration.svg';
import './DayliPromise.css';

const DayliPromise: React.FC = () => {
  return (
    <div className="dayli-promise">
      <div className="promise-content">
        <div className="promise-features">
          <div className="feature-item">
            <div className="promise-feature-icon">
              <img src={securityShieldIcon} alt="Security Shield" />
            </div>
            <span>No damage on credit score</span>
          </div>
          <div className="feature-item">
            <div className="promise-feature-icon">
              <img src={securityShieldIcon} alt="Security Shield" />
            </div>
            <span>Your data stays private.</span>
          </div>
          <div className="feature-item">
            <div className="promise-feature-icon">
              <img src={securityShieldIcon} alt="Security Shield" />
            </div>
            <div className="feature-text-with-logo">
              <span>Secured by Mastercard</span>
              <div className="dayli-promise-mastercard-logo">
                <img src={mastercardLogo} alt="Mastercard Logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3 className="promise-title">Dayli Promise</h3>
      <div className="promise-image">
        <img src={dayliPromiseImage} alt="Dayli Promise" />
      </div>
      <div className="promise-decoration">
        <img src={starDecoration} alt="Star Decoration" />
      </div>
    </div>
  );
};

export default DayliPromise; 